import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Notification } from './notifications.types';

export interface NotificationPopup {
    notification: Notification;
    id: string;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationPopupService {
    private _popupSubject = new Subject<NotificationPopup>();
    public popup$ = this._popupSubject.asObservable();

    /**
     * Show a notification popup
     */
    show(notification: Notification): void {
        const popup: NotificationPopup = {
            notification,
            id: `popup-${Date.now()}-${Math.random()}`
        };
        this._popupSubject.next(popup);
    }
}

